/**
 * Post-login return URL helpers.
 * Only same-origin relative paths are allowed (open-redirect safe).
 */

export const AUTH_RETURN_URL_KEY = 'auth_return_url';

/**
 * Accept only internal relative paths (e.g. /files/123).
 * Reject protocol-relative (//evil.com), absolute URLs, and auth entry points.
 */
export function getSafeReturnUrl(url: string | null | undefined): string | null {
  if (!url || typeof url !== 'string') return null;

  const trimmed = url.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return null;
  if (trimmed.startsWith('/login') || trimmed.startsWith('/auth')) return null;

  return trimmed;
}

export function storeReturnUrl(url: string | null | undefined): void {
  const safe = getSafeReturnUrl(url);
  if (safe) {
    sessionStorage.setItem(AUTH_RETURN_URL_KEY, safe);
  }
}

export function consumeReturnUrl(): string | null {
  const stored = sessionStorage.getItem(AUTH_RETURN_URL_KEY);
  if (stored) {
    sessionStorage.removeItem(AUTH_RETURN_URL_KEY);
  }
  return getSafeReturnUrl(stored);
}
